import { RiskBadge } from '../ui/RiskBadge';
import type { TechDebtItem } from '../../types/org.types';

const SEVERITY_TONE: Record<TechDebtItem['severity'], 'critical' | 'high' | 'medium' | 'low'> = {
  critical: 'critical',
  high: 'high',
  medium: 'medium',
  low: 'low',
};

export function TechDebtTable({ rows }: { rows: TechDebtItem[] }) {
  if (rows.length === 0) {
    return <div className="text-sm text-neutral-500 py-6">No tech debt detected.</div>;
  }
  return (
    <div className="border border-border rounded-md overflow-hidden">
      <table className="w-full text-sm">
        <thead className="bg-surface-2">
          <tr className="text-[11px] uppercase tracking-widest text-neutral-500">
            <th className="text-left px-4 py-3 font-medium">Category</th>
            <th className="text-left px-4 py-3 font-medium">Severity</th>
            <th className="text-right px-4 py-3 font-medium">Count</th>
            <th className="text-left px-4 py-3 font-medium">Details</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((d, i) => (
            <tr key={d.category} className={i % 2 === 0 ? 'bg-surface-1/40' : 'bg-transparent'}>
              <td className="px-4 py-2.5 text-crux-light">{d.category}</td>
              <td className="px-4 py-2.5">
                <RiskBadge tone={SEVERITY_TONE[d.severity]}>
                  {d.severity[0].toUpperCase() + d.severity.slice(1)}
                </RiskBadge>
              </td>
              <td className="px-4 py-2.5 text-right text-neutral-300 tabular-nums">{d.count}</td>
              <td className="px-4 py-2.5 text-neutral-400">{d.details}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
